import { EnableTwoFactorBody, SigninBody } from '@vetahealth/tuna-can-api'
import { AxiosError } from 'axios'

export enum AuthStep {
  SIGNIN = 'signin',
  TWO_FACTOR_SIGNIN = 'twoFactorSignin',
  TWO_FACTOR_RESET_PASSWORD = 'twoFactorResetPassword',
  FORGOT_PASSWORD = 'forgotPassword',
  RESET_PASSWORD = 'resetPassword',
}

export enum SigninType {
  SSO = 'SSO',
  CREDENTIALS = 'CREDENTIALS',
}

export type AuthState = {
  step: AuthStep
  setStep: (step: AuthStep) => void
  resetPasswordUserName?: string
  isAuthorized: boolean
  isInitialized: boolean
  twoFactorId?: string
  trustToken?: string
  trustChallenge?: string
  handleSignin: (signinData: SigninBody) => Promise<void>
  handleTwoFactorSignin: (code: string) => Promise<void>
  handleSignout: () => void
  handleForgotPassword: (userName: string) => Promise<void>
  getTrustToken: (getTrustTokenData: { email: string; code: string }) => Promise<AxiosError['status'] | undefined>
  handleResetPassword: (resetPasswordData: { resetCode: string; newPassword: string }) => Promise<void>
  handleChangePassword: (changePasswordData: {
    password: string
    newPassword: string
    onSuccess: () => void
  }) => Promise<number | undefined>
  getTwoFactorSecret: () => Promise<string | undefined>
  handleEnableTwoFactor: (enableTwoFactorData: EnableTwoFactorBody) => Promise<boolean>
  handleDisableTwoFactor: (code: string) => Promise<boolean>
  setInitialized: () => void
  setIsAuthorized: () => void
  setIsUnauthorized: () => void
  errorStatus?: number
  resetSoft: () => void
}
